/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_My_Integrations_DescriptionInputs */



/**
* | output |
* | --- |
* | "Turn an integration off to stop the assistant using its tools for you. This only affects your account — it does not change what your organization has enabled." |
*
* @param {Connections_My_Integrations_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const connections_my_integrations_description = /** @type {((inputs?: Connections_My_Integrations_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_My_Integrations_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Schalten Sie eine Integration aus, damit der Assistent ihre Tools für Sie nicht mehr verwendet. Das betrifft nur Ihr Konto – die Freigaben Ihrer Organisation bleiben unverändert.")
	return /** @type {LocalizedString} */ ("Turn an integration off to stop the assistant using its tools for you. This only affects your account — it does not change what your organization has enabled.")
});